module.exports = __webpack_public_path__ + "media/store/images/coffeeImage-511bc598d531934e7dbebb869033026b.png";